module.exports = __webpack_public_path__ + "static/media/arrow_down_blue.88a749fa.svg";